module.exports = __webpack_public_path__ + "static/badges-8c319c631011310a01042be727090d1a.jpg";